import { AWXConnectedAccountStatus } from '@ankor-io/common/types/awx'

import { useConnectedAccount } from '@/providers/connectedAccount'
import { useUserContext } from '@/providers/user/useUserContext'
import { Button } from '@/ui-components/Button'
import { DashboardHeader } from '@/views/components/Dashboard/DashboardHeader'
import { QuickActionsBar } from '@/views/components/Dashboard/QuickActionsBar'

export const ConnectedAccountDetail = () => {
  const { activeConnectedAccountId } = useUserContext()
  const { connectedAccounts } = useConnectedAccount()

  const selectedConnectedAccount = connectedAccounts.find((v) => v.id === activeConnectedAccountId)
  return (
    <div className="space-y-6">
      {/* Header Section */}
      <DashboardHeader connectedAccountName={selectedConnectedAccount?.name || ''} />

      {/* if status is CREATED, show a button to open KYC flow */}
      {selectedConnectedAccount?.status === AWXConnectedAccountStatus.CREATED && (
        <div className="flex flex-col gap-2">
          <p className="text-lg font-medium">Activate your account</p>
          <p className="text-sm text-gray-500">Tell us more about your business to activate your account.</p>
          <Button
            color="dark/white"
            className="w-fit"
            to="/kyc-rfi"
          >
            Proceed
          </Button>
        </div>
      )}

      {/* if status is ACTION_REQUIRED, show a button to open KYC RFI flow */}
      {selectedConnectedAccount?.status === AWXConnectedAccountStatus.ACTION_REQUIRED && (
        <div className="flex flex-col gap-2">
          <p className="text-lg font-medium">Information required</p>
          <p className="text-sm text-gray-500">
            We need more information to verify your account before you can use the cards.
          </p>
          <Button
            color="dark/white"
            className="w-fit"
            to="/kyc-rfi"
          >
            Proceed to RFI
          </Button>
        </div>
      )}

      {/* Quick Actions Bar */}
      <QuickActionsBar />
    </div>
  )
}

export default ConnectedAccountDetail
